// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ShareRealizationContentHeader_wrapper__2xZI6","text":"ShareRealizationContentHeader_text__2xM8R","date":"ShareRealizationContentHeader_date__2o0Q-"};